import { LoginSeliseLogo } from '../login-selise-logo';

type LoginBrandLogoProps = {
  className?: string;
};

export const LoginBrandLogo = ({ className }: LoginBrandLogoProps) => {
  return <LoginSeliseLogo className={className} />;
};
